export const UPDATE_SEARCH_CRITERIA = "updateSearchCriteria";

export const updateTemplateSearchCriteria = (
  dispatch,
  deleted,
  draft,
  name,
  offset,
  limit,
) => {
  dispatch({
    type: UPDATE_SEARCH_CRITERIA,
    deleted,
    draft,
    name,
    offset,
    limit,
  });
};
